export default value => value === undefined ? '' : value.toString().replace(/</g, '&lt;');
